import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { cancelPatient } from '../../services/customer.service';
import Dialog from '../ui/Dialog';
import { Grid, TextField } from '@material-ui/core';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';

const CancelPatientAction = ({ data }) => {
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [reason, setReason] = useState("");
    const [optOutDate, setOptOutDate] = useState("");
    const [isLoading, setLoading] = useState(false);
    const { patient_id, program_id, deleted_at } = data;

    const onSubmit = async () => {
        if (window.confirm('Do you want to cancel this patient?')) {
            setLoading(true);
            await cancelPatient({
                program_id,
                customer_id: patient_id,
                payload: {
                    reason: reason,
                    opt_out_date: optOutDate || undefined,
                }
            })
            .then((res) => {
                alert(res.message);
                handleClose(true);
            })
            .catch((err) => alert(err.message))
            .finally(() => {
                setLoading(false);
            })
        }
    };
    
    const handleClose = (reload) => {
        setOpenModal(false);
        setConfirmation(false);

        if (reload) {
            window.location.reload();
        }
    }
    
    const formButtons = (
        <>
            <Button onClick={() => handleClose(false)} variant='contained'>
            Close
            </Button>
            <Button onClick={onSubmit} variant='contained' color='secondary'>
            Cancel
            </Button>
        </>
    );

    const formContent = (
        <>
          <Grid
            item
            container
            xs={12}
            spacing={2}
          >
            <Grid item xs={12}>
                <TextField 
                    multiline={true}
                    rows={4}
                    label='Reason'
                    required={true}
                    name='reason' 
                    variant='outlined'
                    onChange={(e) => setReason(e.target.value)} 
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    type='date'
                    label='Opt out date'
                    name='opt_out_date'
                    variant='outlined'
                    InputLabelProps={{ shrink: true }}
                    value={optOutDate}
                    onChange={(e) => setOptOutDate(e.target.value)}
                />
            </Grid>
          </Grid>
        </>
    );

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return (
        <>
            <Dialog
                key='cancel-patient'
                open={openModal}
                title ='Cancel Patient'
                content = {formContent} 
                children = {formButtons} 
                onSubmit = {onSubmit}
                onClose = {() => handleClose(false)} 
            />
            <Dialog 
                key='confirmation'
                open={openConfirmation}
                title = 'Confirmation'
                content = 'Patient successfully cancelled!' 
                children = {(
                    <Button onClick={() => handleClose(true)} variant='contained'>
                    Close
                    </Button>
                )} 
                onSubmit = {onSubmit}
                onClose = {() => handleClose(true)} 
            />
            {
                deleted_at === null && 
                <Button variant="contained" color="secondary" onClick={() => setOpenModal(true)} 
                style={{ marginRight: 8 }}>Cancel</Button>
            }
        </>
    )
}

export default CancelPatientAction;